import "core-js/modules/es.error.cause.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.json.stringify.js";
import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import questionSettingTemplate from "./questionSettingTemplate.vue";
let uploadAddon = class uploadAddon extends Vue {
  constructor() {
    super(...arguments);
    // isIndeterminatePic = false;
    // isIndeterminateFile = false;
    // isIndeterminateVideo = false;
    this.checkAllFile = false;
    this.checkAllPic = false;
    this.checkAllVideo = false;
    this.picTypes = [".png", ".jpg", ".jpeg", ".webp"];
    this.fileTypes = [".doc", ".docx", ".pdf", ".xls", ".xlsx", ".ppt", ".pptx"];
    this.videoTypes = [".mp4", ".mov"]; //苹果录制格式为mov
    this.postForm = {
      title: "请选择以下选项",
      required: 1,
      uploadLimitCount: 1,
      jsonConfig: {
        subTitle: "",
        picTypes: [],
        fileTypes: [],
        videoTypes: [],
        showIndex: true,
        isIndeterminateFile: false,
        isIndeterminatePic: false,
        isIndeterminateVideo: false
      }
    };
    this.rules = {
      title: [{
        required: true,
        message: "请输入标题",
        type: "string",
        trigger: "blur"
      }],
      required: [{
        required: true,
        message: "请选择是否必填",
        trigger: "blur"
      }],
      uploadLimitCount: [{
        required: true,
        message: "请填写上传文件数量",
        trigger: "blur"
      }],
      "jsonConfig.picTypes": [{
        validator: this.validatorfileType,
        trigger: "blur"
      }]
    };
  }
  watchPropData() {
    if (JSON.stringify(this.value) != JSON.stringify(this.postForm)) {
      this.postForm = JSON.parse(JSON.stringify(this.value));
      this.clearValidate();
      this.$nextTick(() => {
        this.validate();
      });
    }
  }
  watchPostForm() {
    const backup = JSON.parse(JSON.stringify(this.postForm));
    console.log("watchPostForm", backup);
    this.$emit("input", backup);
    this.$emit("change", backup);
  }
  validatorfileType(rule, value, callback) {
    if (this.postForm.jsonConfig.picTypes.length == 0 && this.postForm.jsonConfig.fileTypes.length == 0 && this.postForm.jsonConfig.videoTypes.length == 0) {
      callback(new Error("请选择文件类型"));
    } else {
      callback();
    }
  }
  handleCheckAllChangePic(val) {
    this.postForm.jsonConfig.picTypes = val ? this.picTypes : [];
    this.postForm.jsonConfig.isIndeterminatePic = val;
  }
  handleCheckedChangePic(value) {
    let checkedCount = value.length;
    this.checkAllPic = checkedCount === this.picTypes.length;
    this.postForm.jsonConfig.isIndeterminatePic = checkedCount > 0 && checkedCount < this.picTypes.length;
  }
  handleCheckAllChangeFile(val) {
    this.postForm.jsonConfig.fileTypes = val ? this.fileTypes : [];
    this.postForm.jsonConfig.isIndeterminateFile = val;
  }
  handleCheckedCitiesChangeFile(value) {
    let checkedCount = value.length;
    this.checkAllFile = checkedCount === this.fileTypes.length;
    this.postForm.jsonConfig.isIndeterminateFile = checkedCount > 0 && checkedCount < this.fileTypes.length;
  }
  handleCheckAllChangeVideo(val) {
    this.postForm.jsonConfig.videoTypes = val ? this.videoTypes : [];
    this.postForm.jsonConfig.isIndeterminateVideo = val;
  }
  handleCheckedCitiesChangeVideo(value) {
    let checkedCount = value.length;
    this.checkAllVideo = checkedCount === this.videoTypes.length;
    this.postForm.jsonConfig.isIndeterminateVideo = checkedCount > 0 && checkedCount < this.videoTypes.length;
  }
  getFormInstance() {
    return this.$refs.postForm;
  }
  async validate() {
    return await this.getFormInstance().validate().catch(err => {
      return err;
    });
  }
  clearValidate() {
    if (this.getFormInstance()) {
      this.getFormInstance().clearValidate();
    }
  }
};
__decorate([Prop({
  type: Object,
  default() {
    return {};
  }
})], uploadAddon.prototype, "value", void 0);
__decorate([Prop({
  type: Boolean,
  default: false
})], uploadAddon.prototype, "disabled", void 0);
__decorate([Watch("value", {
  deep: true,
  immediate: true
})], uploadAddon.prototype, "watchPropData", null);
__decorate([Watch("postForm", {
  deep: true
})], uploadAddon.prototype, "watchPostForm", null);
uploadAddon = __decorate([Component({
  name: "uploadAddon",
  components: {
    questionSettingTemplate
  }
})], uploadAddon);
export default uploadAddon;